export default "__VITE_ASSET__a8Wlq_bC__"